import { RepositoryFactory } from 'repository/RepositoryFactory';
import { RETRIEVE_SESSIONS_REQUEST } from 'store/Types/SessionType';
import { RETRIEVE_SESSIONS_FAIL } from 'store/Types/SessionType';
import { RETRIEVE_SESSIONS_SUCCESS } from 'store/Types/SessionType';
import { CREATE_SESSION_FAIL } from 'store/Types/SessionType';
import { CREATE_SESSION_SUCCESS } from 'store/Types/SessionType';
import { CREATE_SESSION_REQUEST } from 'store/Types/SessionType';
let sessionRepo = RepositoryFactory.get('session');


export const createSession = (val) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_SESSION_REQUEST });
    let res = await sessionRepo.createSessionRepo(val);
    if(res){
      dispatch({
        type: CREATE_SESSION_SUCCESS,
        payload: res.data
      });
      alert("Session Created");
    }
    
  } catch (error) {
    dispatch({
      type: CREATE_SESSION_FAIL,
      payload: error
    });
    alert(error?.response.data?.message)

  }
};

export const retrieveAllSessions = (buid) => async (dispatch) => {
  try {

    dispatch({ type: RETRIEVE_SESSIONS_REQUEST });
    let res = await sessionRepo.retrieveAllSessions(buid);

    if (res) {
      dispatch({
        type: RETRIEVE_SESSIONS_SUCCESS,
        payload: res?.data?.data
      });
    }

    return res?.data;

  } catch (error) {

    dispatch({
      type: RETRIEVE_SESSIONS_FAIL,
      payload: error
    });

    return error?.response?.data?.message;
  }
};
